import * as React from 'react';
import * as moment from "moment";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import MaskedDateInput from "../../../hiberUiKit/src/atoms/Input/MaskedDateInput";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * Date format.
	 */
	dateFormat?: string;
}

type Props = ComponentProps & FormGroupProps<moment.Moment> & PlaceholderProps

export default class MaskedDateInputFormGroup extends React.Component<Props, {}> {

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<MaskedDateInput onChange={value => this.props.onChange(this.props.field.updateValue(value))}
								 placeholder={this.props.placeholder}
								 dateFormat={this.props.dateFormat}
								 value={this.props.field.value}/>
			</FormGroup>
		);
	}
}